import { HubConnectionState } from "@microsoft/signalr";

export const DISCONNECTED = {
    connection: null,
    state: HubConnectionState.Disconnected
};
